(function () {
  'use strict';
  if (window.__elongLeadTrackingInstalled) return;
  window.__elongLeadTrackingInstalled = true;
  var prefix = 'elong_lead_v1:';
  function key(formId) { return prefix + location.pathname + ':' + formId; }
  function read(k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; } }
  function write(k, value) { try { sessionStorage.setItem(k, JSON.stringify(value)); return true; } catch (e) { return false; } }
  function debug() { return new URLSearchParams(location.search).get('qa_tracking') === '1'; }
  var destinationConfigured = false;
  var qaStatus = '尚未发送线索事件';
  function showDiagnostics() {
    try {
      if (debug()) sessionStorage.setItem('elong_qa_active', '1');
      if (sessionStorage.getItem('elong_qa_active') !== '1' || !document.createElement) return;
      var box = document.getElementById('elong-qa-status');
      if (!box) {
        box = document.createElement('div');
        box.id = 'elong-qa-status';
        box.style.cssText = 'position:fixed;bottom:12px;left:12px;z-index:2147483647;max-width:360px;padding:12px;background:#fff8db;color:#111;border:2px solid #bc8500;font:14px/1.6 Arial;white-space:pre-line';
        document.body.appendChild(box);
      }
      var pending = read(key('ContactForm'));
      box.textContent = 'ELONG 测试诊断 v3（未发布副本）\n脚本：已运行\n页面：' + location.pathname + '\n成功标记：' + (document.querySelectorAll('[data-elong-lead-success]').length ? '有' : '无') + '\n提交记录：' + (!pending ? '无' : pending.sent ? '已标记发送' : '待成功确认') + '\n事件状态：' + qaStatus + '\n标签处理完成不等于 GA4 已接收';
    } catch (e) {}
  }
  function send(name, params) {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') window.gtag = function () { window.dataLayer.push(arguments); };
    if (!destinationConfigured) {
      window.gtag('config', 'G-8Q8XB39LLS', {send_page_view: false, groups: 'elong_lead_tracking'});
      destinationConfigured = true;
    }
    if (name === 'generate_lead' || name === 'elong_tracking_test') {
      qaStatus = '已加入 Google 发送队列';
      if (!params.event_callback) params.event_callback = function () { qaStatus = 'Google 标签已执行回调'; showDiagnostics(); };
    }
    window.gtag('event', name, params);
    showDiagnostics();
  }
  function recordIntent(form) {
    if (!(form instanceof HTMLFormElement) || !form.matches('.elong-quote-form')) return;
    var type = form.querySelector('input[name="form_type"]');
    if (!type || type.value !== 'contact' || !form.checkValidity()) return;
    var existing = read(key(form.id));
    if (existing && !existing.sent && Date.now() >= existing.at && Date.now() - existing.at <= 1800000) return;
    var attempt = {id: (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2)), at: Date.now(), debug: debug(), sent: false};
    write(key(form.id), attempt);
    showDiagnostics();
  }
  document.addEventListener('submit', function (event) { recordIntent(event.target); }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && !event.isComposing && event.target.tagName === 'INPUT') recordIntent(event.target.form);
  }, true);
  function confirmLead() {
    document.querySelectorAll('[data-elong-lead-success]').forEach(function (marker) {
      if (marker.dataset.trackingProcessed) return;
      marker.dataset.trackingProcessed = 'true';
      var k = key(marker.dataset.formId);
      var attempt = read(k);
      if (!attempt) { qaStatus = '成功页存在，但没有匹配的提交记录'; return; }
      if (attempt.sent) { qaStatus = '已有发送记录，已阻止重复发送'; return; }
      if (Date.now() - attempt.at > 1800000 || Date.now() < attempt.at) { qaStatus = '提交记录已过期'; return; }
      attempt.sent = true;
      if (!write(k, attempt)) return;
      var params = {send_to: 'G-8Q8XB39LLS', lead_source: 'shopify_contact_form', event_id: attempt.id};
      if (attempt.debug) params.debug_mode = true;
      send('generate_lead', params);
    });
    showDiagnostics();
  }
  var lastWhatsApp = {path: '', at: 0};
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button, input[type="submit"], input[type="image"]');
    if (button && !button.disabled && (button.type === 'submit' || button.type === 'image')) recordIntent(button.form);
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var url;
    try { url = new URL(link.href); } catch (e) { return; }
    if (!['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname)) return;
    var destination = url.hostname + url.pathname;
    var now = Date.now();
    if (lastWhatsApp.path === destination && now - lastWhatsApp.at < 1000) return;
    lastWhatsApp = {path: destination, at: now};
    var params = {send_to: 'G-8Q8XB39LLS', contact_method: 'whatsapp', link_domain: url.hostname, transport_type: 'beacon'};
    if (debug()) params.debug_mode = true;
    send('whatsapp_click', params);
  }, true);
  function startTracking() {
    confirmLead();
    if (new URLSearchParams(location.search).get('qa_connection') === '1') {
      qaStatus = '正在检查 Google 标签连接';
      var callbackDone = false;
      var params = {send_to: 'G-8Q8XB39LLS', debug_mode: true, test_source: 'elong_unpublished_qa'};
      params.event_callback = function () { callbackDone = true; qaStatus = 'Google 标签已执行测试回调'; showDiagnostics(); };
      send('elong_tracking_test', params);
      setTimeout(function () {
        if (!callbackDone) { qaStatus = '8秒内未确认标签回调；需继续排查'; showDiagnostics(); }
      }, 8000);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startTracking, {once: true});
  else startTracking();
})();

